export default class RangeFilter {
  constructor(
    protected from: number,
    protected to: number,
    protected min: number,
    protected max: number,
  ) {}

  getMinMax(): [number, number] {
    return [this.min, this.max];
  }

  getMin() {
    return this.min;
  }

  getMax() {
    return this.max;
  }

  getFromTo(): [number, number] {
    return [this.from, this.to];
  }

  getFrom() {
    return this.from;
  }

  getTo() {
    return this.to;
  }

  setMinMax([min, max]: [number, number]) {
    this.min = min;
    this.max = max;
  }

  setFromTo([from, to]: [number, number]) {
    this.from = from;
    this.to = to;
  }

  include(value: number) {
    return this.from <= value && this.to >= value;
  }

  isActive() {
    return this.from > this.min || this.to < this.max;
  }

  mergeRange(next: RangeFilter) {
    const res = new RangeFilter(this.from, this.to, this.min, this.max);
    res.setMinMax([
      res.min > 0 ? Math.min(res.min, next.min) : next.min,
      res.max > 0 ? Math.max(res.max, next.max) : next.max,
    ]);
    res.setFromTo([
      res.from > 0 ? Math.min(res.from, next.from) : next.from,
      res.to > 0 ? Math.max(res.to, next.to) : next.to,
    ]);
    return res;
  }
}
